
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			discount: 0,
			skipNonEmptyDiscount: false
		};
	},
	computed: {},
	methods: {
		apply() {
			this.$emit("update",{discount: this.discount,full: this.skipNonEmptyDiscount});
		},
		cancel() {
			this.$emit("cancel");
		}
	},
	i18nEx: {
		componentPrefix: "components.sales.ApplyDiscount"
	}
});
